import { TextInput } from '@frontend/components/basic-forms';
import { Search } from '@frontend/icons';
import { CommonMessage } from '@frontend/lang';
import { UserBadge } from '@frontend/user/badge';
import { FormattedMessage } from 'react-intl';

import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import usePickUp from './pick-up.controller';

const ID = 'pick-up';

const PickUp = () => {
    const viewProps = usePickUp();

    return (
        <WizardScreenContainer
            id={ID}
            header={{ title: CommonMessage.BUTTONS.PICK_UP }}
            footer={{
                onSubmit: viewProps.onSubmit,
                submitDisabled: viewProps.submitDisabled
            }}
            loadingModal={{ show: viewProps.resolving }}
            errorModal={{
                show: !!viewProps.error,
                title: CommonMessage.ERRORS.UNRECOGNIZED_CODE,
                message: viewProps.error,
                onClose: viewProps.resetError
            }}
            containerClassName='bg-background-default flex flex-1 flex-col items-start justify-start gap-3 self-stretch overflow-y-scroll px-5 pt-6 pb-20'>
            <div className='flex items-start justify-start self-stretch'>
                <div className='text-foreground-default justify-start text-base font-medium'>
                    <FormattedMessage
                        id='pick-up.scan-or-pick-up-code'
                        defaultMessage='Please use the scanner below to fill in your pick-up code or enter it manually'
                    />
                </div>
            </div>
            <div className='inline-flex items-start justify-start gap-2 self-stretch'>
                <TextInput
                    autoFocus
                    value={viewProps.manualPin.length > 0 ? viewProps.manualPin : undefined}
                    onChange={viewProps.setManualPin}
                    className='w-full'
                    placeholder='123456'
                    inputMode='numeric'
                    isClearable
                    isLoading={viewProps.resolving}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter' && viewProps.manualPin.length > 0) {
                            viewProps.resolvePinCode(viewProps.manualPin);
                        }
                    }}
                />

                <button
                    disabled={viewProps.manualPin.length === 0}
                    onClick={() => viewProps.resolvePinCode(viewProps.manualPin)}
                    className='bg-background-surface outline-border-default disabled:bg-brand-disabled flex size-11 items-center justify-between overflow-hidden rounded-xl px-4 outline-1 outline-offset-[-1px] disabled:opacity-30'>
                    <Search className='size-6' />
                </button>
            </div>

            {viewProps.transaction && (
                <div className='flex w-full flex-col items-start justify-start gap-3'>
                    <div className='text-foreground-default justify-start text-base font-medium'>
                        {CommonMessage.DETAIL.DETAILS_OF(CommonMessage.OBJECTS.TRANSACTION.DEFAULT)}
                    </div>
                    <div className='flex w-full flex-col items-start justify-start gap-3'>
                        <div className='bg-background-surface inline-flex w-full flex-col items-start justify-start gap-5 self-stretch rounded-xl p-4'>
                            <div className='inline-flex h-6 items-center justify-between self-stretch'>
                                <div className='text-brand-muted justify-start text-base font-medium'>{CommonMessage.OBJECTS.TRANSACTION.TRACKING_NUMBER}</div>
                                <div className='text-foreground-default justify-start text-base font-medium'>{viewProps.transaction.tracking_number}</div>
                            </div>
                            <div className='inline-flex h-6 items-center justify-between self-stretch'>
                                <div className='text-brand-muted justify-start text-base font-medium'>{CommonMessage.OBJECTS.TRANSACTION.PURCHASE_ORDER}</div>
                                <div className='text-foreground-default justify-start text-base font-medium'>{viewProps.transaction.purchase_order}</div>
                            </div>
                            <div className='inline-flex h-6 items-center justify-between self-stretch'>
                                <div className='text-brand-muted justify-start text-base font-medium'>{CommonMessage.OBJECTS.SUPPLIER.DEFAULT}</div>
                                <div className='text-foreground-default justify-start text-base font-medium'>{viewProps.transaction.supplier ?? '/'}</div>
                            </div>
                            {viewProps.receivers && viewProps.receivers.length > 0 && (
                                <div className='inline-flex h-6 items-center justify-between self-stretch'>
                                    <div className='text-brand-muted justify-start text-base font-medium'>{CommonMessage.OBJECTS.TRANSACTION.RECEIVER}</div>
                                    <UserBadge id={viewProps.receivers[0].user_id || undefined} />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {viewProps.transaction?.shipping_notes && (
                <>
                    <div className='text-foreground-default justify-start text-base font-medium'>{CommonMessage.OBJECTS.TRANSACTION.SHIPPING_NOTES}</div>
                    <div
                        data-state='Open'
                        className='bg-background-surface inline-flex flex-col items-start justify-start gap-5 self-stretch rounded-xl p-4'>
                        <div className='inline-flex items-center justify-between self-stretch'>
                            <div className='flex items-center justify-start gap-4'>{viewProps.transaction.shipping_notes}</div>
                        </div>
                    </div>
                </>
            )}
        </WizardScreenContainer>
    );
};

export default PickUp;
